import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable({
	providedIn: 'root',
})
export class LoadingService {
	loadingVisibility$ = new BehaviorSubject<boolean>(false)

	duration = 3000

	/**
	 * Create an ionic loading animation
	 */
	async showLoading(duration = 3000) {
		this.duration = duration
		this.loadingVisibility$.next(true)
	}

	/**
	 * Dismiss the opened loading animation
	 * @private
	 */
	async closeLoading() {
		this.loadingVisibility$.next(false)
	}
}
